import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TSetQrLink = IAction<ETicketPayment.SET_QR_LINK, string>;

const setQrLink = (link: string): TSetQrLink => ({
    type: ETicketPayment.SET_QR_LINK,
    payload: link,
});

export default setQrLink;
